export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/paymentCard.381116b1.svg","height":23,"width":24,"blurWidth":0,"blurHeight":0};